var _g, _g2, _g3, _g4, _g5, _g6, _g7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "140px",
    height: "140px",
    viewBox: "0 0 140 140",
    enableBackground: "new 0 0 140 140",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#C82027",
    d: "M116.762,19.413L20.654,0.689 C9.593-1.47-0.348,7.498,0.669,18.727l9.662,105.603c0.966,10.543,11.111,17.527,21.281,14.683l95.498-26.622 c8.209-2.312,13.371-10.265,12.099-18.697l-9.024-60.258C129.09,26.271,123.88,20.81,116.762,19.413L116.762,19.413z  M121.033,103.192h-16.349V70.448c0-7.925-0.356-18.772-10.934-18.772c-12.712,0-13.933,12.701-13.933,22.38v29.137H63.47V71.921 c0-9.677-1.705-15.802-5.11-18.341c-1.704-1.271-3.738-1.904-6.179-1.904c-12.586,0-13.882,13.258-13.882,22.785v28.731H22.001 V38.617h16.297v7.419c10.932-12.016,30.943-13.109,39.079,2.541c7.322-10.746,21.711-15.244,33.307-8.689 c9.863,5.385,10.349,15.318,10.349,25.455V103.192z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    d: "M121.035,103.195h-16.349V70.453 c0-7.927-0.354-18.774-10.933-18.774c-12.71,0-13.932,12.703-13.932,22.38v29.137H63.474V71.924c0-9.678-1.705-15.799-5.11-18.34 c-1.705-1.271-3.738-1.906-6.179-1.906c-12.586,0-13.882,13.261-13.882,22.788v28.729H22.005V38.621h16.298v7.417 c10.933-12.015,30.943-13.107,39.078,2.542c7.324-10.747,21.713-15.243,33.307-8.688c9.865,5.387,10.348,15.318,10.348,25.455 V103.195z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMIcon);
export default __webpack_public_path__ + "static/media/m_icon.baed704f04599f14505663851520c71c.svg";
export { ForwardRef as ReactComponent };